<template>
  <div class="filter">
    <div class="flex-row flex-main-axis-end flex-secondary-axis-center">
      <div class="flex-grow-1 flex-unshrink">
        <el-row v-for="(row, i) in buildFields" :key="i" type="flex">
          <template v-for="col in row">
            <!-- @blur="event => col.onBlur && col.onBlur(self, event.target.value)" -->
            <el-input v-if="col.elTag === 'el-input'" :key="col.name" v-model="model[ col.name ]"
              @change="val => col.onChange && col.onChange(self, val)"
              @clear="val => col.onChange && col.onChange(self, val)"
              @keyup.enter.native="event => col.onBlur && col.onBlur(self, event.target.value)"
              v-bind="{ ...col.elProps }" />
            <el-radio-group v-if="col.elTag === 'el-radio-group'" :key="col.name" v-model="model[ col.name ]" v-bind="{ ...col.elProps }">
              <el-radio v-for="el in col.children" :key="el.name" :label="el.value">{{ el.name }}</el-radio>
            </el-radio-group>
            <el-date-picker v-if="col.elTag === 'el-date-picker'" :key="col.name" v-model="model[ col.name ]" @change="val => col.onChange && col.onChange(self, val)" v-bind="{ ...col.elProps }"></el-date-picker>
            <el-select v-if="col.elTag === 'el-select'" :key="col.name" style="width: 100%" v-model="model[ col.name ]" @change="val => col.onChange && col.onChange(self, val)" v-bind="{ ...col.elProps }">
              <el-option
                v-for="selectItem in col.children"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value">
                <div class="select-slot" v-if="selectItem.slot">
                  <span>{{ selectItem.slotLeft || selectItem.name }}</span>
                  <span class="slot-right" v-if="selectItem.slotRight">{{ selectItem.slotRight }}</span>
                </div>
              </el-option>
            </el-select>
          </template>
          <slot name="filter"></slot>
        </el-row>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.filter {
  background: #fff;
  padding: 24px;
  border-radius: 2px;
}
.flex-grow-1 .el-row {
  margin-top: 12px;
}

.flex-grow-1 .el-row:first-child {
  margin-top: 0;
}
.select-slot {
  display: flex;
  justify-content: space-between;
}
.slot-right {
  color: #888;
  font-size: 12px;
  padding-left: 24px;
}
</style>

<script>
import { getModelToOption } from '@/utils/env';

export default {
  name: 'UiFilter',

  props: {
    buildFields: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      model: getModelToOption(this.buildFields),
      self: this
    };
  },

  methods: {
    reset() {
      this.model = getModelToOption(this.buildFields);
      this.$nextTick(() => this.$refs.form.clearValidate());
    }
  }
};
</script>
